import { CodebookModel } from 'app/shared/model/shared.model';

export interface Building {
  idBuilding: number;
  uuid: string;
  constructionBuildingProcedure: CodebookModel[];
  additionalDescription: CodebookModel[];
  buildingPurpose: CodebookModel[];
  buildingPurposeAdditionalDescription: string;
  requirementGroup: CodebookModel[];
  geometryExists: boolean;
  ibz: string;
  buildingExternalSize: string;
  buildingGrossArea: number;
  buildingVolume: number;
  buildingPlacement: CodebookModel[];
  buildingFloorNumberType: string;
  buildingIndependentFunctionalNumber: CodebookModel[];
  constructionCommencement: CodebookModel[];
  buildingTypeNationalClassification: CodebookModel[];
  accessibilityRating: CodebookModel[];
  accessibilityAppliedMeasure: CodebookModel[];
  greenInfrastructureType: CodebookModel[];
  greenInfrastructureArea: number;
  energyCertificateMark: CodebookModel[];
  energyCertificateIssueDate: Date;
  ordering: number;
}

export interface BuildingView {
  idBuilding: number;
  idCase: number;
  idConstructionBuildingProcedure: number;
  idBuildingPurpose: number;
  cbpBuildingPurpose: string;
  buildingPurposeAdditionalDescription: string;
  ibz: string;
  idRequirementGroup: number;
  requirementGroup: string;
  ordering: number;
}

export const initialBuilding = {
  uuid: '',
  constructionBuildingProcedure: [],
  additionalDescription: [],
  buildingPurpose: [],
  buildingPurposeAdditionalDescription: '',
  requirementGroup: [],
  geometryExists: false,
  ibz: '',
  buildingExternalSize: '',
  buildingGrossArea: '',
  buildingVolume: 0,
  buildingPlacement: [],
  buildingFloorNumberType: '',
  buildingIndependentFunctionalNumber: [],
  constructionCommencement: [],
  buildingTypeNationalClassification: [],
  accessibilityRating: [],
  accessibilityAppliedMeasure: [],
  greenInfrastructureType: [],
  greenInfrastructureArea: '',
  energyCertificateMark: [],
  energyCertificateIssueDate: '',
  ordering: 0,
};
